import {Component, OnInit} from '@angular/core';

@Component({
    selector: 'app-ashmtsyllabus',
    templateUrl: './ashmtsyllabus.component.html',
    styleUrls: ['./ashmtsyllabus.component.scss']
})
export class AshmtsyllabusComponent implements OnInit {

    constructor() {
    }

    ngOnInit(): void {
        window.scrollTo(0, 0);
    }

}
